"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTopicFeedLazyQuery = exports.useTopicFeedQuery = exports.TopicFeedDocument = exports.useSpotlightFeedLazyQuery = exports.useSpotlightFeedQuery = exports.SpotlightFeedDocument = exports.usePublishedPremiumStoriesLazyQuery = exports.usePublishedPremiumStoriesQuery = exports.PublishedPremiumStoriesDocument = exports.usePremiumStoryLazyQuery = exports.usePremiumStoryQuery = exports.PremiumStoryDocument = exports.TopicFeedFragmentDoc = exports.TopicFeedStoryFragmentDoc = exports.SpotlightFeedFragmentDoc = exports.SpotlightFeedContextCardFragmentDoc = exports.SpotlightFeedStoryFragmentDoc = exports.SpotlightFeedSnapFragmentDoc = exports.PublishedPremiumStoriesFragmentDoc = exports.PublishedPremiumStoryFragmentDoc = exports.PublishedStoryFragmentDoc = exports.PremiumStoryFragmentDoc = exports.Type = exports.ThumbnailType = exports.SnapMediaType = exports.PublisherType = exports.FeedType = exports.ContextType = exports.Badge = void 0;
const client_1 = require("@apollo/client");
const Apollo = __importStar(require("@apollo/client"));
const defaultOptions = {};
var Badge;
(function (Badge) {
    Badge["STAR"] = "STAR";
    Badge["TICK"] = "TICK";
    Badge["UNSET_BADGE"] = "UNSET_BADGE";
})(Badge = exports.Badge || (exports.Badge = {}));
var ContextType;
(function (ContextType) {
    ContextType["CREATOR"] = "CREATOR";
    ContextType["LENS"] = "LENS";
    ContextType["PLACE"] = "PLACE";
    ContextType["SOUND"] = "SOUND";
    ContextType["UNKNOWN_CONTEXT_TYPE_UNSET"] = "UNKNOWN_CONTEXT_TYPE_UNSET";
})(ContextType = exports.ContextType || (exports.ContextType = {}));
var FeedType;
(function (FeedType) {
    FeedType["SPOTLIGHT"] = "SPOTLIGHT";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
var PublisherType;
(function (PublisherType) {
    PublisherType["NORMAL"] = "NORMAL";
    PublisherType["SHOW"] = "SHOW";
})(PublisherType = exports.PublisherType || (exports.PublisherType = {}));
var SnapMediaType;
(function (SnapMediaType) {
    SnapMediaType["IMAGE"] = "IMAGE";
    SnapMediaType["UNKNOWN"] = "UNKNOWN";
    SnapMediaType["VIDEO"] = "VIDEO";
    SnapMediaType["VIDEO_NO_SOUND"] = "VIDEO_NO_SOUND";
})(SnapMediaType = exports.SnapMediaType || (exports.SnapMediaType = {}));
var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType["ICON"] = "ICON";
    ThumbnailType["UNKNOWN_THUMBNAIL_TYPE_UNSET"] = "UNKNOWN_THUMBNAIL_TYPE_UNSET";
    ThumbnailType["WAVEFORM"] = "WAVEFORM";
})(ThumbnailType = exports.ThumbnailType || (exports.ThumbnailType = {}));
var Type;
(function (Type) {
    Type["COMMUNITY"] = "COMMUNITY";
    Type["DISCOVER"] = "DISCOVER";
    Type["DYNAMIC"] = "DYNAMIC";
    Type["FEATURED"] = "FEATURED";
    Type["LENS_STORY"] = "LENS_STORY";
    Type["LIVE_STREAM"] = "LIVE_STREAM";
    Type["MAPS"] = "MAPS";
    Type["MAPS_SINGLE_SNAP"] = "MAPS_SINGLE_SNAP";
    Type["PUBLIC_MY_STORY_SNAP"] = "PUBLIC_MY_STORY_SNAP";
    Type["PUBLIC_USER_SNAP"] = "PUBLIC_USER_SNAP";
    Type["PUBLIC_USER_STORY"] = "PUBLIC_USER_STORY";
    Type["SHARED_OUR_STORY_SNAP"] = "SHARED_OUR_STORY_SNAP";
    Type["SHARED_SINGLE_SNAP"] = "SHARED_SINGLE_SNAP";
    Type["STORY_FEED"] = "STORY_FEED";
    Type["STORY_ID"] = "STORY_ID";
    Type["UNKNOWN"] = "UNKNOWN";
})(Type = exports.Type || (exports.Type = {}));
exports.PremiumStoryFragmentDoc = (0, client_1.gql) `
    fragment PremiumStory on PremiumStory {
  story {
    id
    snaps {
      id
      index
      snapMediaType
      snapUrls {
        mediaUrl
        mediaPreviewUrl
      }
      intervalStartTimeMs
    }
    type
    thumbnailUrl
    videoTrackUrl
  }
}
    `;
exports.PublishedStoryFragmentDoc = (0, client_1.gql) `
    fragment PublishedStory on Story {
  id
  title
  thumbnailUrl
  type
  videoTrackUrl
}
    `;
exports.PublishedPremiumStoryFragmentDoc = (0, client_1.gql) `
    fragment PublishedPremiumStory on PremiumStory {
  story {
    ...PublishedStory
  }
  publishedTimeInSec
  seasonNumber
  episodeNumber
  ownerBusinessProfileId
}
    ${exports.PublishedStoryFragmentDoc}`;
exports.PublishedPremiumStoriesFragmentDoc = (0, client_1.gql) `
    fragment PublishedPremiumStories on PublishedPremiumStoriesConnection {
  premiumStories {
    ...PublishedPremiumStory
  }
  pageInfo {
    nextCursor
  }
}
    ${exports.PublishedPremiumStoryFragmentDoc}`;
exports.SpotlightFeedSnapFragmentDoc = (0, client_1.gql) `
    fragment SpotlightFeedSnap on Snap {
  id
  snapMediaType
  snapUrls {
    mediaUrl
    mediaPreviewUrl
  }
  snapTitle
  snapSubtitles
}
    `;
exports.SpotlightFeedStoryFragmentDoc = (0, client_1.gql) `
    fragment SpotlightFeedStory on Story {
  id
  snaps {
    ...SpotlightFeedSnap
  }
  title
  thumbnailUrl
  subtitle
  canonicalUrlSuffix
  emoji
  type
  tapId
}
    ${exports.SpotlightFeedSnapFragmentDoc}`;
exports.SpotlightFeedContextCardFragmentDoc = (0, client_1.gql) `
    fragment SpotlightFeedContextCard on ContextCard {
  contextType
  title
  subtitle
  url
  thumbnailUrl
  hasBadge
  snapcodeUrl
  thumbnailType
}
    `;
exports.SpotlightFeedFragmentDoc = (0, client_1.gql) `
    fragment SpotlightFeed on Feed {
  type
  stories {
    story {
      ...SpotlightFeedStory
    }
    metadata {
      hashtags
      contextCards {
        ...SpotlightFeedContextCard
      }
      videoMetadata {
        name
        description
        thumbnailUrl
        uploadDateMs
        contentUrl
        creator {
          username
          url
        }
      }
      engagementStats {
        viewCount
        shareCount
      }
    }
  }
}
    ${exports.SpotlightFeedStoryFragmentDoc}
${exports.SpotlightFeedContextCardFragmentDoc}`;
exports.TopicFeedStoryFragmentDoc = (0, client_1.gql) `
    fragment TopicFeedStory on Story {
  id
  snaps {
    id
    snapMediaType
    snapUrls {
      mediaUrl
      mediaPreviewUrl
    }
  }
  title
  thumbnailUrl
  type
}
    `;
exports.TopicFeedFragmentDoc = (0, client_1.gql) `
    fragment TopicFeed on Feed {
  type
  stories {
    story {
      ...TopicFeedStory
    }
  }
}
    ${exports.TopicFeedStoryFragmentDoc}`;
exports.PremiumStoryDocument = (0, client_1.gql) `
    query PremiumStory($storyId: String!, $country: String!) {
  premiumStory(storyId: $storyId, country: $country) {
    ...PremiumStory
  }
}
    ${exports.PremiumStoryFragmentDoc}`;
/**
 * __usePremiumStoryQuery__
 *
 * To run a query within a React component, call `usePremiumStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumStoryQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      country: // value for 'country'
 *   },
 * });
 */
function usePremiumStoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(exports.PremiumStoryDocument, options);
}
exports.usePremiumStoryQuery = usePremiumStoryQuery;
function usePremiumStoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(exports.PremiumStoryDocument, options);
}
exports.usePremiumStoryLazyQuery = usePremiumStoryLazyQuery;
exports.PublishedPremiumStoriesDocument = (0, client_1.gql) `
    query PublishedPremiumStories($businessProfileId: ID!, $seasonId: ID, $cursor: ID!, $limit: Int!, $country: String!) {
  publisher(businessProfileId: $businessProfileId) {
    businessProfileId
    publishedPremiumStoriesConnection(
      first: $limit
      from: $cursor
      seasonId: $seasonId
      country: $country
    ) {
      ...PublishedPremiumStories
    }
  }
}
    ${exports.PublishedPremiumStoriesFragmentDoc}`;
/**
 * __usePublishedPremiumStoriesQuery__
 *
 * To run a query within a React component, call `usePublishedPremiumStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedPremiumStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedPremiumStoriesQuery({
 *   variables: {
 *      businessProfileId: // value for 'businessProfileId'
 *      seasonId: // value for 'seasonId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      country: // value for 'country'
 *   },
 * });
 */
function usePublishedPremiumStoriesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(exports.PublishedPremiumStoriesDocument, options);
}
exports.usePublishedPremiumStoriesQuery = usePublishedPremiumStoriesQuery;
function usePublishedPremiumStoriesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(exports.PublishedPremiumStoriesDocument, options);
}
exports.usePublishedPremiumStoriesLazyQuery = usePublishedPremiumStoriesLazyQuery;
exports.SpotlightFeedDocument = (0, client_1.gql) `
    query SpotlightFeed($country: String!, $locale: String!, $storiesToFilter: [Long!]!) {
  spotlightFeed(
    country: $country
    locale: $locale
    storiesToFilter: $storiesToFilter
  ) {
    ...SpotlightFeed
  }
}
    ${exports.SpotlightFeedFragmentDoc}`;
/**
 * __useSpotlightFeedQuery__
 *
 * To run a query within a React component, call `useSpotlightFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotlightFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotlightFeedQuery({
 *   variables: {
 *      country: // value for 'country'
 *      locale: // value for 'locale'
 *      storiesToFilter: // value for 'storiesToFilter'
 *   },
 * });
 */
function useSpotlightFeedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(exports.SpotlightFeedDocument, options);
}
exports.useSpotlightFeedQuery = useSpotlightFeedQuery;
function useSpotlightFeedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(exports.SpotlightFeedDocument, options);
}
exports.useSpotlightFeedLazyQuery = useSpotlightFeedLazyQuery;
exports.TopicFeedDocument = (0, client_1.gql) `
    query TopicFeed($country: String!, $locale: String!, $topic: String!) {
  hashtagFeed(country: $country, locale: $locale, topic: $topic) {
    ...TopicFeed
  }
}
    ${exports.TopicFeedFragmentDoc}`;
/**
 * __useTopicFeedQuery__
 *
 * To run a query within a React component, call `useTopicFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicFeedQuery({
 *   variables: {
 *      country: // value for 'country'
 *      locale: // value for 'locale'
 *      topic: // value for 'topic'
 *   },
 * });
 */
function useTopicFeedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(exports.TopicFeedDocument, options);
}
exports.useTopicFeedQuery = useTopicFeedQuery;
function useTopicFeedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(exports.TopicFeedDocument, options);
}
exports.useTopicFeedLazyQuery = useTopicFeedLazyQuery;
//# sourceMappingURL=graphql.js.map